<template>
    <div class="mt-md-4">

        <div class="collapse" :id="collapseId" :data-parent="parentCollapseId">
            <location-filter v-if="shouldShowAllFilters" class="pb-4"></location-filter>
            <div class="row justify-content-center" v-if="filters">

                <div class="col-lg-2 filter-column h-100v border-bottom" v-bind:class="{'border-top': index === 0}" v-if="!filter.data.hide" v-show="showFilter(filter.id)" v-for="(filter, key, index) in filters">
                    <page-filter
                            class="h-100"
                            :view-type="'desktop'"
                                      :page-filter-type="filter.id"
                                      :id="filter.id"
                                      :id-prefix="'mobile'"
                                      :icon="filter.data.faIcon"
                                      :plural="filter.data.plural"
                                      :input-name="filter.id"
                                      :items="filter.values"
                                      :more-breakpoint="10000"
                                      v-on:show-specific-filter="showSpecificFilter"
                                      v-on:show-all-filters="showAllFilters"
                    ></page-filter>
                </div>
            </div>

            <div v-if="showBottomSpacer" class="pt-10"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            collapseId: {
                type: String,
                default: '',
            },
            parentCollapseId: {
                type: String,
                default: '',
            },
            showBottomSpacer: {
                type: Boolean,
                default: false,
            },
            idPrefix: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                filters: [],
                // Mutators
                shouldShowAllFilters: true,
                currentFilter: null,
                refreshFiltersOnce: false
            };
        },
        mounted() {

            VueEvents.$on('loaded_filters', filters => {
                if(false === this.refreshFiltersOnce) {
                    this.filters = filters;
                    this.refreshFiltersOnce = true;
                }
            });
        },
        methods: {
            showAllFilters() {
                this.currentFilter = null;
                this.shouldShowAllFilters = true;
            },

            showSpecificFilter(filter) {
                this.shouldShowAllFilters = false;
                this.currentFilter = filter;
            },

            showFilter(filter) {
                if (this.shouldShowAllFilters) {
                    return true;
                }

                return this.currentFilter === filter;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/MovieFiltersMobile.vue